import { Button, Result } from 'antd'
import React from 'react'

const backHomeFn = () => {
  window.location.href = `${window.location.origin}#/login`;
}


const Nopermission = () => {
  return (
    <div>
      <Result
        status="403"
        title="401"
        subTitle="Sorry,Your token has expired, please log in again."
        extra={<Button type="primary" onClick={() => backHomeFn()}>Back Login</Button>}
      />
    </div>
  )
}
export default Nopermission